import { useCallback } from 'react';
import { useInstantSearch, useToggleRefinement } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';

import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { useInSeasonLocalStorage } from '@sorare/core/src/hooks/search/useInSeasonLocalStorage';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

const FILTER = TOGGLE_FILTERS.inSeasonFilter;

const Filter = () => {
  const {
    refine,
    value: { isRefined },
  } = useToggleRefinement({
    attribute: FILTER.attribute,
  });
  const track = useEvents();
  const { indexUiState } = useInstantSearch();
  const [, setInSeason] = useInSeasonLocalStorage();

  const handleChange = useCallback(
    (newValue: boolean) => {
      track('Use Market Filter', {
        filterName: FILTER.attribute,
        filterValue: newValue.toString(),
      });

      refine({ isRefined });
      setInSeason(newValue);
    },
    [track, refine, isRefined, setInSeason]
  );

  // we rather consider the refinement state from the UI
  // so that we don't rely on the Algolia answer to come back to reflect the slider state
  const optimisticRefined = !!indexUiState.toggle?.[FILTER.attribute];

  return (
    <div className="FilterWidget visible isActiveWidget">
      <TextSwitch
        value={optimisticRefined}
        options={[
          {
            label: (
              <BodyM bold>
                <FormattedMessage defaultMessage="In-Season" />
              </BodyM>
            ),
            value: true,
          },
          {
            label: (
              <BodyM bold>
                <FormattedMessage defaultMessage="All" />
              </BodyM>
            ),
            value: false,
          },
        ]}
        onChange={handleChange}
      />
    </div>
  );
};

export const widget: FilterWidget = {
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: Filter,
};
